<template>
	<div>
		<div class="banner">和优秀的人，做有挑战的事</div>
		
		<div class="product-list-page">
		
			<!-- <h1>产品展示</h1> -->
			<div class="product-list-container">
						  
			  <div class="filters">
				<h2>筛选产品</h2>
				<div class="filter-group">
				  <label for="field-filter">适用领域:</label>
				  <select id="field-filter" v-model="selectedField">
					<option value="">全部</option>
					<option v-for="field in uniqueFields" :key="field" :value="field">{{ field }}</option>
				  </select>
				</div>
				<div class="filter-group">
				  <label for="type-filter">产品类型:</label>
				  <select id="type-filter" v-model="selectedType">
					<option value="">全部</option>
					<option v-for="type in uniqueTypes" :key="type" :value="type">{{ type }}</option>
				  </select>
				</div>
			  </div>
						
			  <div class="product-list">
				<div v-for="product in paginatedProducts" :key="product.id" class="product-card">
				  <img :src="product.image" :alt="product.name" class="product-image" />
				  <div class="product-info">
					<h2 class="product-name">{{ product.name }}</h2>
					<p class="product-field">适用领域: {{ product.field }}</p>
					<p class="product-summary">{{ product.summary }}</p>
					<router-link :to="'/products/' + product.id" class="product-details-link">查看详情</router-link>
				  </div>
				</div>
				<div class="pagination">
				  <button @click="prevPage" :disabled="currentPage === 1">上一页</button>
				  <span>第 {{ currentPage }} 页，共 {{ totalPages }} 页</span>
				  <button @click="nextPage" :disabled="currentPage === totalPages">下一页</button>
				</div>
			  </div>
						
			</div>
		</div>
	</div>
  
</template>

<script>
import axios from "axios";
import { getProductList } from "@/api/product";
export default {
  
  name: 'products',
data() {
  return {
    // 替换原来的 products 为 jobCategories（接口返回的 list）
    jobCategories: [], // 接口返回的产品列表
    total: 0, // 总数
    currentPage: 1,
    productsPerPage: 10, // 每页显示数量
    selectedField: '',
    selectedType: ''
  };
},
created() {
  this.fetchProducts(this.currentPage, this.productsPerPage);
},
computed: {
  filteredProducts() {
    return this.jobCategories.filter(product => {
      return (
        (!this.selectedField || product.field === this.selectedField) &&
        (!this.selectedType || product.type === this.selectedType)
      );
    });
  },
  paginatedProducts() {
    const startIndex = (this.currentPage - 1) * this.productsPerPage;
    return this.filteredProducts.slice(startIndex, startIndex + this.productsPerPage);
  },
  totalPages() {
    return Math.ceil(this.filteredProducts.length / this.productsPerPage);
  },
  uniqueFields() {
    return [...new Set(this.jobCategories.map(p => p.field))];
  },
  uniqueTypes() {
    return [...new Set(this.jobCategories.map(p => p.type))];
  }
},
  methods: {
    async fetchProducts(page = 1, pageSize = 10, keyword = "") {
      try {
        const res = await getProductList({ page, pageSize, keyword });

        if (res.data.status === 200) {
          // 映射后端数据到前端需要的字段
          this.jobCategories = res.data.data.list.map(item => ({
            id: item.id,
            name: item.name || item.zh_name,   // 兼容不同字段
            field: item.field || "其它",        // 默认值
            type: item.type || "检测设备",      // 默认值
            summary: item.summary || "暂无简介",
            image: item.image.startsWith("http")
              ? item.image
              : this.$serverUrl + item.image,
            description: item.description || ""
          }));
          this.total = res.data.data.total;
        } else {
          this.$message.error(res.data.msg || "获取产品失败");
        }
      } catch (err) {
        console.error("请求出错:", err);
        this.$message.error("网络错误，加载产品失败");
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    }
  }
};
</script>

<style scoped>
	
.banner {
  height: 200px;
  line-height: 200px;
  color: #fff;
  width: 100%;
  min-width: @main-width;
  background-image: url("../../assets/images/product.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  text-align: center;
  font-size: @font-size-larger;
}

.product-list-page {
  padding: 20px;
  width: 80%;
  margin: auto;
}

.product-list-container {
  display: flex;
}

.filters {
  width: 20%;
  padding: 20px;
  background-color: #f4f4f4;
  border-radius: 8px;
  margin-right: 20px;
}

.filters h2 {
  margin-bottom: 20px;
}

.filter-group {
  margin-bottom: 20px;
}

.filter-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 1.1em;
}

.filter-group select {
  width: 100%;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #ddd;
  font-size: 1em;
  outline: none;
  transition: border-color 0.3s;
}

.filter-group select:focus {
  border-color: #007bff;
}

.filter-group option {
  font-size: 1em;
  padding: 10px;
}

.product-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.product-card {
  display: flex;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
  align-items: center;
}

.product-card:hover {
  transform: translateY(-5px);
}

.product-image {
  width: 150px;
  height: auto;
  border-radius: 8px;
  margin-right: 20px;
}

.product-info {
  flex: 1;
}

.product-name {
  font-size: 1.5em;
  margin: 10px 0;
}

.product-field, .product-summary {
  color: #555;
  margin: 8px 0;
}

.product-details-link {
  display: inline-block;
  margin-top: 10px;
  padding: 8px 12px;
  background-color: #007bff;
  color: white;
  border-radius: 4px;
  text-decoration: none;
  transition: background-color 0.3s;
}

.product-details-link:hover {
  background-color: #0056b3;
}

.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
}

.pagination button {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.3s;
  margin: auto;
}

.pagination button:hover {
  background-color: #0056b3;
}

.pagination span {
  font-size: 1em;
}
</style>
